import { useState } from "react";
import {
  MDBCard,
  MDBCardHeader,
  MDBCardTitle,
  MDBCardBody,
} from "mdb-react-ui-kit";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useTranslation } from "react-i18next";
import { usePayMutation } from "./Library.state";
import { Button, Row, Col } from "../App.styles";
import { Alert, Spinner } from "../common";
import {
  ImageCol,
  LibraryRow,
  LibraryCol,
  CaptionRow,
  PaymentForm,
  PaymentCol,
  TagRow,
  TagListWrapper,
  Tag,
} from "./Library.styles";
import premium from "../images/premium.png";
import usePayment from "../lib/usePayment";

const stripeStyles = {
  style: {
    base: {
      fontSize: "16px",
    },
  },
};

const LibraryPreview = () => {
  const { t } = useTranslation();
  const stripe = useStripe();
  const elements = useElements();
  const [show, setShow] = useState(false);
  const [paid, setPaid] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const { isPaying, pay } = usePayMutation();
  const { doPayment } = usePayment();

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    const cardElement = elements.getElement(CardElement);

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
    });

    if (error) {
      setErrorMessage(error.message);
      console.error("[Library] Payment Error: ", error);
      window.scrollTo(0, 0);
      return;
    }

    const { id } = paymentMethod;
    doPayment({
      action: () => pay(id),
      onSuccess: () => setPaid(true),
      onError: setErrorMessage,
    })
  };

  return (
    <>
      <Row>
        <Alert color="danger">{errorMessage}</Alert>
      </Row>
      <Row>
        <Col className="col--stretch">
          <MDBCard className="flex-grow-1">
            <MDBCardHeader>
              <MDBCardTitle>{t('Premium Library')}</MDBCardTitle>
            </MDBCardHeader>
            <MDBCardBody>
              <LibraryRow>
                <ImageCol size="12" md="6">
                  <img alt={t("Premium Library")} src={premium} />
                </ImageCol>
                <LibraryCol size="12" md="6">
                  <h3>{t('Need some')}</h3>
                  <h2>{t('inspiration?')}</h2>
                  <p>{t('Browse our all-time favorite challenges.')}</p>
                  <h4>{t('Unlock the premium library')}</h4>
                  <p>
                    <strong>$ 299 USD</strong>
                    <Button color="danger" onClick={() => setShow(true)}>
                      {t('Pay Now')}
                    </Button>
                  </p>
                  <p>{t('You will find fun, creative and sure fire hit options.')}</p>
                </LibraryCol>
              </LibraryRow>
              <CaptionRow>
                {show ? (
                  <PaymentForm onSubmit={handleSubmit}>
                    <PaymentCol size="12" lg="8">
                      <CardElement options={stripeStyles} />
                    </PaymentCol>
                    <Col size="12" lg="3">
                      <Button type="submit" color="danger">
                        {t('Pay Now')} {isPaying && <Spinner size="0.875rem" />}
                      </Button>
                    </Col>
                  </PaymentForm>
                ) : (
                  <>
                    <Col size="6">{t('Unique categories')}</Col>
                    <Col size="6">{t('Variety of types')}</Col>
                  </>
                )}
              </CaptionRow>
              <TagRow>
                <Col size="12" md="6">
                  <p>
                    <strong>{t('Search using tags')}</strong> {t(`applied by our curators and
                    with just one tap add them to your game.`)}
                  </p>
                </Col>
                <Col size="12" md="6">
                  <TagListWrapper>
                    <Tag><span dangerouslySetInnerHTML={{__html:t('#trivia')}} /></Tag>
                    <Tag><span dangerouslySetInnerHTML={{__html:t('#riddles')}} /></Tag>
                    <Tag><span dangerouslySetInnerHTML={{__html:t('#park')}} /></Tag>
                    <Tag><span dangerouslySetInnerHTML={{__html:t('#indoors')}} /></Tag>
                    <Tag><span dangerouslySetInnerHTML={{__html:t('#puzzles')}} /></Tag>
                    <Tag><span dangerouslySetInnerHTML={{__html:t('#location')}} /></Tag>
                    <Tag><span dangerouslySetInnerHTML={{__html:t('#hilarious')}} /></Tag>
                  </TagListWrapper>
                </Col>
              </TagRow>
            </MDBCardBody>
          </MDBCard>
          {paid ? (
            <img
              alt=""
              src={`${process.env.REACT_APP_CONVERSION_PAY}&value=29900&currency_code=${process.env.REACT_APP_CURRENCY_CODE}`}
              style={{ width: "1px", height: "1px" }}
            />
          ) : (
            <img
              alt=""
              src={process.env.REACT_APP_CONVERSION_BUILD}
              style={{ width: "1px", height: "1px" }}
            />
          )}
        </Col>
      </Row>
    </>
  );
};

export default LibraryPreview;
